import axios from "@/api/config";

const question = {
  getQuestionById(data) {
    return axios.get(
      `${process.env.BASE_URL}/question/getQuestion/` + data,
      {}
    );
  },
  getQuestion(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestion`, {
      params: data
    });
  },

  getQuestionList(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionList`, {
      params: data
    });
  },
  getQuestionTree(data) {
    return axios.get(`${process.env.BASE_URL}/question/getQuestionTree`, {
      params: data
    });
  },
  questionTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/questionTypeList`, {
      params: data
    });
  },
  questionTypeNormalList(data) {
    return axios.get(
      `${process.env.BASE_URL}/questionType/questionTypeNormalList`,
      { params: data }
    );
  },
  questionTypeByExam(data) {
    return axios.get(
      `${process.env.BASE_URL}/questionType/questionTypeByExam`,
      { params: data }
    );
  },
  pageListSelectByExam(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/pageListSelectByExam`,
      data
    );
  },

  questionTypeBigList(data) {
    return axios.get(
      `${process.env.BASE_URL}/questionType/questionTypeBigList`,
      { params: data }
    );
  },
  questionListByExam(data) {
    return axios.get(`${process.env.BASE_URL}/question/questionListByExam`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageList`, data);
  },
  pageListSpecial(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/pageListBySpecialExercise`,
      data
    );
  },
  pageListByChapter(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/pageListByChapter`,
      data
    );
  },
  getQuestionListByChapter(params) {
    return axios.get(
      `${process.env.BASE_URL}/question/getQuestionListByChapter`,
      { params }
    );
  },
  pageListByExam(data) {
    return axios.post(`${process.env.BASE_URL}/question/pageListByExam`, data);
  },
  addQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addQuestion`, data);
  },
  addNormalQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addNormalQuestion`,
      data
    );
  },
  updateNormalQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/updateNormalQuestion`,
      data
    );
  },
  addBigQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/addBigQuestion`, data);
  },
  updateBigQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/updateBigQuestion`,
      data
    );
  },
  addSmallQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/addSmallQuestion`,
      data
    );
  },
  updateSmallQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/updateSmallQuestion`,
      data
    );
  },
  deleteQuestion(data) {
    return axios.post(`${process.env.BASE_URL}/question/deleteQuestion`, data);
  },
  updateQuestion(data) {
    return axios.put(`${process.env.BASE_URL}/question/updateQuestion`, data);
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/question/exportExcel`, {
      params: data
    });
  },
  getTitleById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getTitleById`, {
      params: data
    });
  },
  getInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/question/getInfoById`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/question/importData`, data);
  },
  importQuestionByWord(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/importQuestionByWord`,
      data
    );
  },
  deleteChapterQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/deleteChapterQuestion`,
      data
    );
  },
  deleteExamQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/deleteExamQuestion`,
      data
    );
  }
};

export default question;



// WEBPACK FOOTER //
// ./src/api/question.js